import { Tag, Badge } from "antd";
import { cust, ba, dp, mainFee, emp, ln, pa } from "api/endpoints";
import CreatedByInfo from "components/CreatedByInfo";
import getColumnSearchProps from "components/common/getColumnSearchProps";
import { Link } from "react-router-dom";
import { formatCurrency } from "utils/formatter";

const fintIssueCols = [
  {
    title: "Код",
    dataIndex: "DictId",
    align: "center",
    width: "100px",
  },
  {
    title: "Шалтгаан",
    dataIndex: "Name",
  },
  {
    title: "Төрөл",
    dataIndex: "Type",
    align: "center",
    render: (val) =>
      val === "Return" ? (
        <Tag color="blue">Буцаалт</Tag>
      ) : val === "Blacklist" ? (
        <Tag color="black">Хар жагсаалт</Tag>
      ) : val === "Waitlist" ? (
        <Tag color="gold">Хүлээлэг</Tag>
      ) : val === "Deny" ? (
        <Tag color="red">Татгалзах</Tag>
      ) : val === "ExtDeny" ? (
        <Tag color="red">Сунгах хүсэлт татгалзах</Tag>
      ) : (
        <Tag>{val}</Tag>
      ),
  },
  {
    title: "Эрэмбэ",
    dataIndex: "OrderNo",
    align: "center",
    width: "100px",
  },
];

const custCols = [
  {
    title: "Төрөл",
    dataIndex: "CustType",
    width: "150px",
    ...getColumnSearchProps({
      type: "select",
      dtSrc: [
        { val: "Хувь хүн", txt: "Хувь хүн" },
        { val: "Байгууллага", txt: "Байгууллага" },
      ],
    }),
    render: (_, rec) => {
      return <div>{rec.CustTypeName}</div>;
    },
  },
  {
    title: "Код",
    dataIndex: "CustCode",
    width: "150px",
    ...getColumnSearchProps({}),
  },
  {
    title: "Овог нэр",
    dataIndex: "CustName",
    ...getColumnSearchProps({}),
  },
  {
    title: "Дансны дугаар",
    dataIndex: "BankAcntNo",
    ...getColumnSearchProps({}),
  },
  {
    title: "Регистр",
    dataIndex: "RegNo",
    textAlign: "center",
    ...getColumnSearchProps({}),
  },
  {
    title: "Утас",
    dataIndex: "Phone1",
    textAlign: "center",
    ...getColumnSearchProps({}),
  },
];

const dpProdCols = [
  {
    title: "Код",
    dataIndex: "ProdCode",
    width: "150px",
    ...getColumnSearchProps({}),
  },
  {
    title: "Нэр",
    dataIndex: "Name",
    ...getColumnSearchProps({}),
  },
  {
    title: "Төрөл",
    dataIndex: "IsActive",
    align: "center",
    render: (val) => <Badge color={val ? "green" : "red"} text={val ? "Идэвхтэй" : "Идэвхгүй"} />,
  },
];

const lnProdCols = [
  {
    title: "Код",
    dataIndex: "ProdCode",
    width: "150px",
    ...getColumnSearchProps({}),
  },
  {
    title: "Нэр",
    dataIndex: "Name",
    ...getColumnSearchProps({}),
  },
  {
    title: "Төрөл",
    dataIndex: "IsActive",
    align: "center",
    render: (val) => <Badge color={val ? "green" : "red"} text={val ? "Идэвхтэй" : "Идэвхгүй"} />,
  },
  {
    title: "Төлөв",
    dataIndex: "IsActive",
    render: (val) => (
      <Badge
        style={{ width: "100%", textAlign: "center" }}
        color={val ? "green" : "red"}
        text={val ? "Идэвхтэй" : "Идэвхгүй"}
      />
    ),
  },
];

const baProdsCols = [
  {
    title: "Код",
    dataIndex: "ProdCode",
    width: 100,
  },
  {
    title: "Нэр",
    dataIndex: "Name",
    textAlign: "center",
  },
  {
    title: "Ерөнхий дэвтэр",
    dataIndex: "Gl",
    textAlign: "center",
    width: 200,
  },
  {
    title: "Төрөл",
    dataIndex: "Type",
    textAlign: "center",
    render: (val) => <div>{val === "Active" ? "Актив" : "Пассив"}</div>,
  },
  {
    title: "Валют",
    dataIndex: "CurCode",
    textAlign: "center",
  },
  {
    title: "Төлөв",
    dataIndex: "IsActive",
    render: (val) => (
      <Badge
        style={{ width: "100%", textAlign: "center" }}
        color={val ? "green" : "red"}
        text={val ? "Идэвхтэй" : "Идэвхгүй"}
      />
    ),
  },
];

const baBankAcntsCols = [
  {
    title: "Банк",
    dataIndex: "BankName",
    width: "20%",
  },
  {
    title: "Дансны дугаар",
    dataIndex: "BankAcntNo",
    textAlign: "center",
  },
  {
    title: "Дансны нэр",
    dataIndex: "BankAcntName",
  },
];

const baAcntsCols = [
  {
    title: "Дансны дугаар",
    dataIndex: "AcntNo",
  },
  {
    title: "Нэр",
    dataIndex: "Name",
  },
  {
    title: "Дансны төрөл",
    dataIndex: "IsPassive",
    textAlign: "center",
    width: 200,
    render: (val) => (val ? <Tag color="blue">Пассив</Tag> : <Tag color="green">Актив</Tag>),
  },
  {
    title: "Ерөнхий дэвтэр",
    dataIndex: "Gl",
    textAlign: "center",
    width: 200,
  },

  {
    title: "Үлдэгдэл",
    dataIndex: "CrntBal",
    align: "end",
  },
  {
    title: "Битүүмж",
    dataIndex: "HoldBal",
    render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Төлөв",
    dataIndex: "IsOpen",
    width: "100px",
    render: (val) => (
      <Badge
        style={{ width: "100%", textAlign: "center" }}
        color={val ? "green" : "red"}
        text={val ? "Идэвхтэй" : "Идэвхгүй"}
      />
    ),
  },
];

const paFeeMainCols = [
  {
    title: "Шимтгэлийн нэр",
    dataIndex: "Name",
    textAlign: "center",
  },
  {
    title: "Дансны дугаар",
    dataIndex: "BaAcntNo",
    textAlign: "center",
  },
  {
    title: "Гүйлгээний төрөл",
    dataIndex: "TxnType",
    textAlign: "center",
  },
  {
    title: "Төрөл",
    dataIndex: "Type",
    render: (val) => <div>{val === "Inc" ? "Орлого" : "Зарлага"}</div>,
    textAlign: "center",
  },
  {
    title: "Тооцооллын арга",
    dataIndex: "CalcMethod",
    render: (val) => <div>{val === "Const" ? "Тогтмол" : val === "Prcnt" ? "Хувиар" : "Формула"}</div>,
    textAlign: "center",
  },
  {
    title: "Шимтгэл",
    dataIndex: "Fee",
    textAlign: "center",
    render: (val) => (
      <Badge
        style={{ width: "100%", textAlign: "center" }}
        color={val ? "green" : "red"}
        text={val ? "Идэвхтэй" : "Идэвхгүй"}
      />
    ),
  },
];

const admUserCols = [
  {
    title: "Салбар",
    dataIndex: "BrchId",
    align: "left",
    // render: (val, rec) => `${val} - ${rec.brchName}`,
  },
  {
    title: "Код",
    dataIndex: "UserId",
    width: "10%",
    ...getColumnSearchProps({}),
  },
  {
    title: "Овог",
    dataIndex: "LastName",
    align: "left",
  },
  {
    title: "Нэр",
    dataIndex: "FirstName",
    align: "left",
    ...getColumnSearchProps({}),
  },
  {
    title: "Регистр",
    dataIndex: "RegNo",
    width: "100px",
    ...getColumnSearchProps({}),
  },
  {
    title: "Утас",
    dataIndex: "Phone",
    width: "100px",
    ...getColumnSearchProps({}),
  },
];

const lnAcntCols = [
  {
    title: "Данс",
    dataIndex: "AcntNo",
    ...getColumnSearchProps({}),
  },
  {
    title: "Дансны нэр",
    dataIndex: "AcntName",
    ...getColumnSearchProps({}),
  },
  {
    title: "Харилцагч",
    dataIndex: "CustCode",
    render: (val) => {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link target="_blank" to={`${cust.person}/${val}`}>
            {val}
          </Link>
        </div>
      );
    },
    ...getColumnSearchProps({}),
  },
  // {
  //   title: "Огноо",
  //   dataIndex: "BeginDate",
  //   render: (value, rec) => (
  //     <Tag color="blue">{`${formatDate(value)} - ${formatDate(rec.EndDate)} (${rec?.UseDays})`}</Tag>
  //   ),
  // },
  {
    title: "Олгосон дүн",
    dataIndex: "AdvAmt",
    render: (val) => (
      <div
        style={{
          textAlign: "right",
        }}
      >
        {formatCurrency(val)}
      </div>
    ),
  },
  {
    title: "Үндсэн зээл",
    dataIndex: "PrincBal",
    render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Хур.Хүү",
    dataIndex: "AccBaseInt",
    render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Үндсэн зээл өр",
    dataIndex: "DuePrincBal",
    render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Үндсэн хүү өр",
    dataIndex: "DueBaseInt",
    render: (val, rec) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Нэм.хүү",
    dataIndex: "FineInt",
    render: (val, rec) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Бал.Гад үндсэн хүү",
    dataIndex: "ObBaseInt",
    render: (val, rec) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Бал.Гад Нэм.хүү",
    dataIndex: "ObFineInt",
    render: (val, rec) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
];

const DpAcntCols = [
  {
    title: "Данс",
    dataIndex: "AcntNo",
    textAlign: "center",
    ...getColumnSearchProps({}),
  },
  {
    title: "Дансны нэр",
    dataIndex: "AcntName",
    ...getColumnSearchProps({}),
  },
  {
    title: "Бүтээгдэхүүн",
    dataIndex: "ProdCode",
    render: (val, rec) => <div style={{ textAlign: "left" }}>{`${val}. ${rec?.ProdName}`}</div>,
    ...getColumnSearchProps({ type: "number" }),
  },
  {
    title: "Харилцагч",
    dataIndex: "CustCode",
    textAlign: "center",
    render: (val) => {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Link target="_blank" to={`${cust.person}/${val}`}>
            {val}
          </Link>
        </div>
      );
    },
    ...getColumnSearchProps({}),
  },
  {
    title: "Төлөв",
    dataIndex: "IsOpen",
    width: "130px",
    render: (val) => (val ? <Badge color={"green"} text={"Идэвхтэй"} /> : <Badge color={"red"} text={"Идэвхгүй"} />),
  },
  {
    title: "Үлдэгдэл",
    dataIndex: "CurrBal",
    width: "140px",
    render: (val) => (
      <div
        style={{
          textAlign: "right",
        }}
      >
        {formatCurrency(val)}
      </div>
    ),
  },
  {
    title: "Битүүмж",
    dataIndex: "HoldBal",
    width: "140px",
    render: (val) => (
      <div
        style={{
          textAlign: "right",
        }}
      >
        {formatCurrency(val)}
      </div>
    ),
  },
];

const baAcntCols = [
  {
    title: "Дансны дугаар",
    dataIndex: "AcntNo",
    textAlign: "center",
  },
  {
    title: "Нэр",
    dataIndex: "Name",
  },
  {
    title: "Валют",
    dataIndex: "CurCode",
    textAlign: "center",
  },
  {
    title: "Үлдэгдэл",
    dataIndex: "CrntBal",
    render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Битүүмж",
    dataIndex: "HoldBal",
    render: (val) => <div style={{ textAlign: "right" }}>{formatCurrency(val)}</div>,
  },
  {
    title: "Төлөв",
    dataIndex: "IsOpen",
    width: "100px",
    render: (val) => (
      <Badge
        style={{ width: "100%", textAlign: "center" }}
        color={val ? "green" : "red"}
        text={val ? "Идэвхтэй" : "Идэвхгүй"}
      />
    ),
  },
];

const baNostroCols = [
  {
    title: "Дансны дугаар",
    dataIndex: "AcntNo",
    width: "100px",
    textAlign: "center",
  },
  {
    title: "Дотоодын дансны нэр",
    dataIndex: "Name",
  },
  {
    title: "Банк",
    dataIndex: "BankCode",
  },
  {
    title: "Банкны данс",
    dataIndex: "BankAcntNo",
    textAlign: "center",
  },
  {
    title: "Банкны дансны нэр",
    dataIndex: "BankAcntName",
  },
  {
    title: "Үндсэн",
    dataIndex: "IsDefault",
    fieldType: "select",
    width: "150px",
    render: (val) => (val ? <Tag color="blue">Тийм</Tag> : <Tag color="red">Үгүй</Tag>),
  },
];
const paBranchCols = [
  {
    title: "Салбарын дугаар",
    dataIndex: "BrchId",
    textAlign: "center",
  },
  {
    title: "Салбарын нэр",
    dataIndex: "Name",
    textAlign: "center",
  },
  {
    title: "Захирал",
    dataIndex: "Director",
    textAlign: "center",
  },
  {
    title: "Утас",
    dataIndex: "Phone",
    textAlign: "center",
  },
  {
    title: "Үндсэн эсэх",
    dataIndex: "IsDefault",
    render: (val) => (val ? <Tag color="green">Тийм</Tag> : <Tag color="red">Үгүй</Tag>),
  },
  {
    title: "Төлөв",
    dataIndex: "IsActive",
    render: (val) => (
      <Badge
        style={{ width: "100%", textAlign: "center" }}
        color={val ? "green" : "red"}
        text={val ? "Идэвхтэй" : "Идэвхгүй"}
      />
    ),
  },
];
const lnAppCols = [
  {
    title: "Өргөдлийн №",
    dataIndex: "AppNo",
    align: "left",
  },
  {
    title: "Бүтээгдэхүүн",
    dataIndex: "ProdCode",
    render: (_, rec) => rec?.ProdName,
  },
  {
    title: "Хүү /Жилийн/",
    dataIndex: "IntRate",
    render: (val) => `${val}%`,
  },
  {
    title: "Хүссэн дүн",
    dataIndex: "Amt",
    render: (val) => formatCurrency(val),
  },
  {
    title: "Баталсан дүн",
    dataIndex: "AppAmt",
    render: (val) => formatCurrency(val),
  },
  {
    title: "Тайлбар",
    dataIndex: "Note",
    align: "left",
  },
  {
    title: "Төлөв",
    dataIndex: "Status",
    render: (val, rec) => {
      return (
        <>
          {val === "New" ? (
            <Tag color="blue">Шинэ</Tag>
          ) : val === "Allow" ? (
            <Tag color="green">Зөвшөөрсөн</Tag>
          ) : val === "Deny" ? (
            <Tag color="red">Татгалзсан</Tag>
          ) : (
            <Tag>{val}</Tag>
          )}
        </>
      );
    },
  },
  {
    title: "Эдийн засагч",
    dataIndex: "LoId",
    render: (val) => <CreatedByInfo UserId={val} />,
  },
];

export const browseType = (type, addition) => {
  if (type === "ISSUERETURN") {
    return {
      endpoints: cust.fintIssueDicts,
      title: "Буцаалтын шалтгааны жагсаалт",
      isPost: true,
      params: {
        Type: "Return",
      },
      columns: fintIssueCols,
    };
  } else if (type === "ISSUEDENY") {
    return {
      endpoints: cust.fintIssueDicts,
      title: "Татгалзах шалтгааны жагсаалт",
      isPost: true,
      params: {
        Type: "Deny",
      },
      columns: fintIssueCols,
    };
  } else if (type === "ISSUEEXTDENY") {
    return {
      endpoints: cust.fintIssueDicts,
      title: "Сунгах хүсэлт татгалзах шалтгааны жагсаалт",
      isPost: true,
      params: {
        Type: "ExtDeny",
      },
      columns: fintIssueCols,
    };
  } else if (type === "ISSUEBLACKLIST") {
    return {
      endpoints: cust.fintIssueDicts,
      title: "Хар жагсаалтын шалтгааны жагсаалт",
      isPost: true,
      params: {
        Type: "Blacklist",
      },
      columns: fintIssueCols,
    };
  } else if (type === "ISSUEWAITLIST") {
    return {
      endpoints: cust.fintIssueDicts,
      title: "Гар хүлээлгийн шалтгааны жагсаалт",
      isPost: true,
      params: {
        Type: "Waitlist",
      },
      columns: fintIssueCols,
    };
  } else if (type === "CUSTOMER") {
    return {
      endpoints: cust.customers,
      title: "Харилцагчийн жагсаалт",
      isPost: true,
      columns: custCols,
    };
  } else if (type === "DPPROD") {
    return {
      endpoints: dp.products,
      title: "Бүтээгдэхүүний жагсаалт",
      isPost: true,
      columns: dpProdCols,
    };
  } else if (type === "LNPROD") {
    return {
      endpoints: ln.products,
      title: "Бүтээгдэхүүний жагсаалт",
      isPost: true,
      columns: lnProdCols,
    };
  } else if (type === "BAPRODS") {
    return {
      endpoints: ba.products,
      title: "Бүтээгдэхүүний жагсаалт",
      isPost: true,
      columns: baProdsCols,
    };
  } else if (type === "BABANKACNTS") {
    return {
      endpoints: ba.bankAccounts,
      title: "Банкны дансны жагсаалт",
      isPost: true,
      columns: baBankAcntsCols,
    };
  } else if (type === "BAACNTSFILTER") {
    return {
      endpoints: ba.accounts,
      title: "Дансны жагсаалт",
      isPost: true,
      columns: baAcntCols,
      params: {
        IsPassive: false,
      },
    };
  } else if (type === "FEEMAIN") {
    return {
      endpoints: mainFee.feeMainList,
      title: "Функцын жагсаалт",
      isPost: true,
      columns: paFeeMainCols,
    };
  } else if (type === "ADMUSER") {
    return {
      endpoints: `${emp.emps}`,
      endpoint: emp.emp,
      title: "Хэрэглэгчийн жагсаалт",
      isPost: true,
      columns: admUserCols,
      params: {
        IsActive: true,
      },
    };
  } else if (type === "LNACNT") {
    return {
      endpoints: `${ln.accounts}`,
      endpoint: ln.account,
      title: "Зээлийн дансны жагсаалт",
      isPost: true,
      columns: lnAcntCols,
      primaryKey: "AcntNo",
      params: {
        Status: "Open",
      },
    };
  } else if (type === "DPACNT") {
    return {
      endpoints: `${dp.accounts}`,
      endpoint: dp.account,
      title: "Депозит дансны жагсаалт",
      isPost: true,
      columns: DpAcntCols,
      primaryKey: "AcntNo",
    };
  } else if (type === "BAACNT") {
    return {
      endpoints: ba.accounts,
      title: "Дотоодын дансны жагсаалт",
      isPost: true,
      columns: baAcntCols,
      primaryKey: "AcntNo",
    };
  } else if (type === "PASSIVEACNT") {
    return {
      endpoints: ba.accounts,
      title: "Пассив дансны жагсаалт",
      isPost: true,
      columns: baAcntCols,
      primaryKey: "AcntNo",
      params: {
        ProdType: "Passive",
      },
    };
  } else if (type === "NOSTRO") {
    return {
      endpoints: ba.nostros,
      title: "Ностро дансны жагсаалт",
      isPost: true,
      columns: baNostroCols,
      primaryKey: "AcntNo",
    };
  } else if (type === "BRCHS") {
    return {
      endpoints: pa.branches,
      title: "Салбарын жагсаалт",
      isPost: true,
      columns: paBranchCols,
      primaryKey: "AcntNo",
    };
  } else if (type === "LNAPPS") {
    return {
      endpoints: ln.applications,
      title: "Зээлийн өргөдөлийн жагсаалт",
      isPost: true,
      columns: lnAppCols,
      primaryKey: "AppNo",
      params: {
        Status: "Allow",
        CustCode: addition,
      },
    };
  }
};
